<script setup>
  import { onMounted } from 'vue';
  import { useFelixBagAuxStore } from '../../../store';

  const felixBagAuxStore = useFelixBagAuxStore();

  onMounted(() => {
    felixBagAuxStore.pauseAfter(9000)
  });

</script>

<template>
  <div id="final-acolhimento">
  </div>
</template>

<style>
#final-acolhimento {}
</style>